import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-ink-950 px-3 py-12 sm:px-4 sm:py-16" data-id="element-63" data-mp="1hifzdacqmyex">
      <div className="mx-auto max-w-2xl lg:max-w-5xl" data-id="element-64" data-mp="1clpk2p8rc6uk">
        <div className="flex justify-center" data-id="element-65" data-mp="18k4d1kiwmmsa">
          <span className="flex items-center gap-2 rounded-full border border-brand-500/40 bg-brand-500/10 px-3.5 py-1.5 text-[11px] font-black uppercase tracking-[0.14em] text-brand-400" data-id="element-66" data-mp="18l5lricg6x6u">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="20c1ymiyid1u4" />
            Bonus inclusi
          </span>
        </div>

        <h2 className="mt-4 text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-68" data-mp="1w7c8zbug0jhn">
          Inoltre riceverai <span className="text-brand-400" data-id="element-69" data-mp="ku08naxw6j08">GRATIS</span> questi 5
          strumenti clinici
        </h2>
        <p className="mx-auto mt-3 max-w-md text-center text-[15px] leading-relaxed text-white/60" data-id="element-70" data-mp="fux6pzd7kswh">
          Non sono semplici file aggiuntivi. Sono risorse che potrai utilizzare
          concretamente nella tua pratica clinica.
        </p>

        <div className="mt-7 space-y-5" data-id="element-71" data-mp="1jrgi73ezi9o4">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-3xl border border-white/10 bg-ink-900 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center" data-id="element-72" data-mp="15trtfkhsqids">
              <div className="bg-white p-2 sm:p-3" data-id="element-73" data-mp="w2drz76ab8i0">
                <img src={bonus.image} alt={`Mockup del ${bonus.label}: ${bonus.title}`} className="mx-auto block w-full max-w-none" loading="lazy" data-id="element-74" data-mp="10tm07zvvontl" />
              </div>

              <div className="p-4 sm:p-5" data-id="element-75" data-mp="r4c7qix4h34y">
                <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-76" data-mp="d4kzyzx78ize">
                  <span className="rounded-lg bg-brand-500/15 px-2.5 py-1 text-[11px] font-black uppercase tracking-[0.16em] text-brand-400" data-id="element-77" data-mp="i3ebwnwu81xg">
                    {bonus.label}
                  </span>
                  <span className="text-[12.5px] font-bold text-white/40" data-id="element-78" data-mp="2f1v7fbtfl0nh">
                    Valore: <span className="line-through" data-id="element-79" data-mp="2f00izniyaqen">{bonus.value}</span>{' '}
                    <span className="text-brand-400 no-underline" data-id="element-80" data-mp="2b0rnad4coigg">GRATIS</span>
                  </span>
                </div>
                <h3 className="mt-3 text-[19px] font-extrabold leading-snug text-white sm:text-[22px]" data-id="element-81" data-mp="25zc3eodwshzn">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-white/65" data-id="element-82" data-mp="2yr5ksj5pf9if">{bonus.text}</p>
              </div>
            </article>)}
        </div>

        <p className="mt-6 text-center text-[14px] font-bold text-white/70" data-id="element-83" data-mp="2orwtxz64yb0a">
          Valore totale dei 5 bonus:{' '}
          <span className="text-white line-through" data-id="element-84" data-mp="1ibujff0vyo78">€185</span>{' '}
          <span className="text-brand-400" data-id="element-85" data-mp="1dchmg1gaw0qx">→ inclusi oggi gratis</span>
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-86" data-mp="1deko5iqtfibh">
          <CTAButton label="Voglio il sistema + i 5 bonus" sublabel="Tutti i bonus inclusi oggi, senza costi extra" data-id="element-87" data-mp="139cbxcbwzzgc" />
        </div>
      </div>
    </section>;
}